export const environment = {
  production: false,
  authUrl: 'https://testidp.unomain.com/oauth/token',
  shopUrl: 'https://shoptest.unomain.com',
  shopApiUrl: 'https://testapi.unomain.com/shop/api',
  primeApiUrl: 'https://testapi.unomain.com/prime/api',
  imageApiUrl: 'https://images.unomain.com/files/upload',
  imageUrl: 'https://images.unomain.com/coxpchxeixfgmngjgrvov2/upl/',
  regionalApi: 'https://testregionalapi.unomain.com',
  oms: 'https://omsapi.unomain.com',
  apiEndpoints: {
    products: 'products',
    countries: 'countries',
    couriers: 'couriers',
    states: 'states',
    cities: 'cities',
    zones: 'zones',
    prices: 'prices',
  },
};
// nvm use 14.21.3
// ng build
